import { createFileRoute } from '@tanstack/react-router'

import { MFAPage } from '@/pages/MFAPage'

export const Route = createFileRoute('/mfa')({
  component: RouteComponent,
})

function RouteComponent() {
  return <MFAPage />
}
